import { fork, call, put, takeLeading, select, takeLatest } from 'redux-saga/effects';
import { AccessLevel, AccountCore, Product } from '@dev/ee-api/ee-api-models';

import { getBillingPlanList, getProductsList } from '@/services/ApiCategories/products';
import { ProductActionTypes, DashboardProduct, LoadBillingPlans } from '@/store/products/types';
import { PlansLoaded, PlansLoadingError, ProductListLoaded, ProductListLoadingError } from '@/store/products/actions';
import { getProductUrl } from '@/services/tools/getProductUrl';
import { getAccountAccessLevel, getGeneralInfo } from '@/store/account/actions';
import { errorToast } from './commonGenerators/errorToast';

function* getProducts(): any {
    try {
        const accessLevels: AccessLevel[] = yield select(getAccountAccessLevel);
        if(!accessLevels?.includes(AccessLevel.ViewBilling)) return  yield put(ProductListLoaded([]));

        const resp = yield call(getProductsList);
        const products = resp.data.map(
            (product: Product): DashboardProduct => ({
                ...product,
                ...{
                    dashboardURL: getProductUrl(product.Code),
                },
            })
        );
        const dashboards = products.filter((product: Product) => !product.IsAddon);

        yield put(ProductListLoaded(dashboards));
    } catch (e) {
        yield put(ProductListLoadingError());
        yield call(errorToast, e);
    }
}

function* getBillingPlans(action: LoadBillingPlans): any {
    const { payload } = action;
    const { IsSub,AccountAccessLevel }: AccountCore = yield select(getGeneralInfo);

    if (IsSub || !AccountAccessLevel?.includes(AccessLevel.ViewBilling)) {
        return yield put(PlansLoaded([]));
    }
  
    try {
        const resp = yield call(getBillingPlanList, payload.billingPlanCode);
        yield put(PlansLoaded(resp.data));
    } catch (e) {
        yield put(PlansLoadingError());
        yield call(errorToast, e);
    }
}

function* watchGetProducts(): any {
    yield takeLeading(ProductActionTypes.LOAD_PRODUCT_LIST, getProducts);
}

function* watchGetBillingPlan(): any {
    yield takeLatest(ProductActionTypes.LOAD_BILLING_PLANS, getBillingPlans);
}

const productSagas = [fork(watchGetProducts), fork(watchGetBillingPlan)];

export default productSagas;
